import styles from './GeoZoneLoad.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import WaitLoader from "../../WaitLoader/WaitLoader";
export default function GeoZoneLoad(){

    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const [fileSelected, setFileSelected] = useState(false)
    const data = useRef(new FormData())
    const [ldrXlsFile,rsXlsFile,exXlsFile] = useApiQuery("/excel/upload","file",data);

    const macroRegionListRef = useRef<SelectUnitRefInt>(null)


    const regionAllList = useRef()
    const [ldrRegionAll,rsRegionAll,exRegionAll] = useApiQuery("/ref/macro/all","get",regionAllList);
    const [regionAllListData, setRegionAllListData] = useState<any[]>([])
    const [macroRegionSelected, setMacroRegionSelected] = useState<number>(0)


    const [macroRegionList,setMacroRegionList] = useState<SelectUnitDataInt[]>([])

    const loadMacroRegionData = useRef({
        macroRegionId:0,
        filePath:"",

    })
    const [ldrLoadMacroRegion,rsLoadMacroRegion,exLoadMacroRegion] = useApiQuery("/geo/zone/load","post",loadMacroRegionData);



    useEffect(()=>{
        exRegionAll().then((e)=>{
            if(e.success && Array.isArray(e?.payload))
            {
                //console.log(e?.payload)
                setRegionAllListData(e?.payload)
                const a:SelectUnitDataInt[] = e?.payload?.map((item:any)=>{
                    return{
                        name: item?.name,
                        val: item?.macroRegionId
                    }

                })
                setMacroRegionList(a)
                return
            }
        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e.errorAsString : "Ошибка сервера",true,3000)
        })
    },[regionAllList])

    const handleFile = (e :React.ChangeEvent<HTMLInputElement>) =>{
        data.current.delete("file")
        if(! e.target.files)
        {
            setFileSelected(false)
            return
        }
        if(e.target.files.length > 0 )setFileSelected(true)
        else setFileSelected(false)
        data.current.append("file",e.target.files[0])
    }


    const handleLoad = () =>{
        if(errorLineRef.current)errorLineRef.current.clear()
        if(!fileSelected)
        {
            if(errorLineRef.current !== null)errorLineRef.current.show("Файл не выбран",true,2000)
            return
        }
        if(!macroRegionSelected)
        {
            if(errorLineRef.current !== null)errorLineRef.current.show("Файл не макрорегион",true,2000)
            return
        }

        exXlsFile().then((e)=>{
            if(e?.success !== undefined && e.success && e?.payload)
            {
                console.log("payload",e?.payload)
                loadMacroRegionData.current.filePath = e?.payload
                loadMacroRegionData.current.macroRegionId = macroRegionSelected

                exLoadMacroRegion().then((e)=>{
                    if(e?.success )
                    {
                        //checkTaskResult(e?.payload)
                        if(errorLineRef.current)errorLineRef.current.show("Задача выполенеа",false,5000)

                        return

                    }
                    if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка выполнения задачи" ,true,2000)
                }).catch((e)=>{
                    console.log(e)
                    if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,2000)
                })
                return

            }
            if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки файла" ,true,2000)
        }).catch((e)=>{
            if(errorLineRef.current !== null)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,2000)
        })



    }

    return(
        <div className={styles.mainCont} >
            <MainFormTemplate title={"Загрузить геозоны доставки"} maxWidth={"800px"}>
                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <div className={styles.suCont}>
                            <SelectUnit ref={macroRegionListRef} inData={macroRegionList} capt={"Макрорегион"} getVal={(e)=>{
                                if(! e.length) setMacroRegionSelected(0)
                                else setMacroRegionSelected(e[0])
                            }}  />
                        </div>
                    </div>

                    <div className={"col-sm-6"}>
                        <input type="file" className="form-control" accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                               onChange={(e)=>handleFile(e)}
                        >
                        </input>
                    </div>


                </div>

                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                <div className={"row mt-2"}>
                    <div className={"col-sm-2 d-flex align-self-center"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={()=>handleLoad()}
                                    disabled={ldrLoadMacroRegion}
                            >Загрузить</button>
                            <WaitLoader loading={ldrLoadMacroRegion} api={rsLoadMacroRegion} onlyLoading={true}>

                            </WaitLoader>


                        </div>
                    </div>
                </div>



            </MainFormTemplate>
        </div>

    )
}
